// ============================================
// AVISOPRIVACIDAD.JS — Aviso de privacidad publico: /privacidad (2026-10-14)
// ============================================
// PUBLICA: Meta exige una URL de politica de privacidad accesible SIN login para publicar la app de
// WhatsApp Cloud API. Va fuera del UsuarioProvider (como /verificar y /garantia) para que la abra
// cualquiera sin cuenta.
// Contenido 100% ESTATICO: no llama al backend ni lee la BD, no muestra datos de clientes, precios ni
// usuarios. Cambiar el texto = editar este archivo y subir.
// Datos del responsable: copiados de "Datos de la empresa" (empresa_datos); a confirmar por Ricardo.
// Lo que todavia no se tiene va como null y se pinta como PENDIENTE visible: NUNCA se inventa.

import React, { useEffect } from 'react';
import { ShieldCheck } from 'lucide-react';

const AZUL = '#265F97', GRIS = '#3D4248', GRIS_CLARO = '#5E666E', BORDE = '#D7D9DB';

const RESPONSABLE = {
  razonSocial: 'Comercializadora Beep México, S.A. de C.V.',
  domicilio: 'Avenida del Olivar de los Padres 1036, int. 408, Col. Olivar de los Padres, Alcaldía Álvaro Obregón, C.P. 01780, Ciudad de México',
  correoArco: 'rherrera@beepmx.com',   // correo ARCO (Ricardo, 2026-10-15)
};
const ULTIMA_ACTUALIZACION = '15 de octubre de 2026';

function Pendiente({ que }) {
  return (
    <span style={{ background: '#FFF4D6', color: '#9A5B00', border: '1px dashed #E0B354', borderRadius: 6, padding: '1px 8px', fontWeight: 700, fontSize: 13 }}>
      PENDIENTE: {que}
    </span>
  );
}

const correoArco = () => RESPONSABLE.correoArco
  ? <a href={`mailto:${RESPONSABLE.correoArco}`} style={{ color: AZUL, fontWeight: 600 }}>{RESPONSABLE.correoArco}</a>
  : <Pendiente que="correo de contacto" />;

export default function AvisoPrivacidad() {
  useEffect(() => { document.title = 'Aviso de privacidad · Beep México'; }, []);

  const wrap = { minHeight: 'calc(var(--beep-vh) * 100)', background: '#F3F5F8', fontFamily: "'Poppins', system-ui, -apple-system, Segoe UI, Roboto, sans-serif", color: GRIS, padding: '16px 12px 40px', boxSizing: 'border-box' };
  const cont = { maxWidth: 760, margin: '0 auto', display: 'grid', gap: 14 };
  const card = { background: '#fff', borderRadius: 14, border: `1px solid ${BORDE}`, padding: '18px 20px', boxShadow: '0 4px 14px rgba(38,95,151,0.06)', minWidth: 0 };
  const h2 = { fontSize: 15.5, fontWeight: 700, color: AZUL, margin: '0 0 8px' };
  const p = { fontSize: 14, lineHeight: 1.7, margin: '0 0 10px', overflowWrap: 'anywhere' };
  const ul = { fontSize: 14, lineHeight: 1.7, margin: '0 0 10px', paddingLeft: 20 };

  const Seccion = ({ n, titulo, children }) => (
    <section style={card}>
      <h2 style={h2}>{n}. {titulo}</h2>
      {children}
    </section>
  );

  return (
    <div style={wrap}>
      <main style={cont}>
        <header style={{ background: 'linear-gradient(90deg,#0F3A6B,#2E7AC4)', color: '#fff', borderRadius: 14, padding: '18px 20px' }}>
          <img src="/Logo%20Horizontal%20blanco.png" alt="Beep México" style={{ height: 26, display: 'block', marginBottom: 10 }} />
          <div style={{ fontSize: 12, letterSpacing: 1.2, opacity: 0.85, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 6 }}>
            <ShieldCheck size={15} /> AVISO DE PRIVACIDAD INTEGRAL
          </div>
          <h1 style={{ fontSize: 20, margin: '6px 0 0', fontWeight: 700 }}>Cómo tratamos tus datos personales</h1>
          <div style={{ fontSize: 12.5, marginTop: 6, opacity: 0.85 }}>Última actualización: {ULTIMA_ACTUALIZACION}</div>
        </header>

        <Seccion n={1} titulo="Responsable de tus datos">
          <p style={p}>
            <strong>{RESPONSABLE.razonSocial}</strong> (en adelante, “Beep México”), con domicilio en {RESPONSABLE.domicilio},
            es responsable del uso y protección de tus datos personales, conforme a la Ley Federal de Protección de Datos
            Personales en Posesión de los Particulares y su normativa aplicable.
          </p>
          <p style={{ ...p, margin: 0 }}>Para cualquier asunto relacionado con este aviso puedes escribirnos a: {correoArco()}</p>
        </Seccion>

        <Seccion n={2} titulo="Qué datos recabamos">
          <p style={p}>Para las finalidades de este aviso podemos recabar los siguientes datos, que nos proporcionas directamente (en persona, por teléfono, correo, nuestro sitio o WhatsApp):</p>
          <ul style={ul}>
            <li>Datos de identificación y contacto: nombre, teléfono y correo electrónico.</li>
            <li>Datos de la empresa que representas: razón social, RFC, domicilio fiscal y de instalación, y el puesto de la persona de contacto.</li>
            <li>El contenido de los mensajes que nos envías por WhatsApp y otros medios (texto, imágenes, documentos, notas de voz y ubicaciones que decidas compartir).</li>
          </ul>
          <p style={{ ...p, margin: 0 }}>No solicitamos datos personales sensibles. Te pedimos no enviarlos por ningún medio.</p>
        </Seccion>

        <Seccion n={3} titulo="Para qué los usamos">
          <p style={p}>Usamos tus datos para las siguientes finalidades, necesarias para la relación que tienes con nosotros:</p>
          <ul style={{ ...ul, margin: 0 }}>
            <li>Atender tus solicitudes, dudas y mensajes.</li>
            <li>Elaborar y enviarte cotizaciones.</li>
            <li>Dar seguimiento a tus proyectos, instalaciones, garantías y servicios.</li>
            <li>Facturar y cumplir con nuestras obligaciones fiscales y legales.</li>
          </ul>
        </Seccion>

        <Seccion n={4} titulo="Mensajes de WhatsApp">
          <p style={p}>
            Cuando escribes a nuestro número de WhatsApp Business, los mensajes que envías y las respuestas que te damos se
            procesan para darte atención y <strong>quedan registrados en nuestro sistema interno</strong>, para que cualquier
            persona de nuestro equipo que te atienda conozca el historial de tu solicitud.
          </p>
          <p style={{ ...p, margin: 0 }}>
            El servicio de WhatsApp lo presta WhatsApp (Meta Platforms), que trata los datos de sus usuarios conforme a sus
            propias condiciones y política de privacidad. Solo te responderemos por ese medio cuando tú nos hayas escrito
            primero o nos hayas pedido que te contactemos así.
          </p>
        </Seccion>

        <Seccion n={5} titulo="Con quién compartimos tus datos">
          <p style={p}><strong>No vendemos, rentamos ni compartimos tus datos con terceros con fines comerciales o publicitarios.</strong></p>
          <p style={{ ...p, margin: 0 }}>
            Solo los comunicamos a proveedores que nos prestan servicios necesarios para operar (por ejemplo, alojamiento de
            nuestro sistema, mensajería y facturación electrónica), que actúan por nuestra cuenta y no pueden usarlos para fines
            propios, y a las autoridades cuando una ley o una orden competente nos lo exija.
          </p>
        </Seccion>

        <Seccion n={6} titulo="Tus derechos ARCO">
          <p style={p}>
            Tienes derecho a <strong>Acceder</strong> a tus datos, a <strong>Rectificarlos</strong> si son inexactos, a pedir su
            <strong> Cancelación</strong> cuando consideres que no se requieren para las finalidades de este aviso, y a
            <strong> Oponerte</strong> a su uso para fines específicos. También puedes revocar el consentimiento que nos hayas
            dado o limitar el uso de tus datos, salvo cuando los necesitemos para cumplir una obligación legal o un contrato vigente.
          </p>
          <p style={p}>Para ejercerlos, envía tu solicitud a {correoArco()} indicando:</p>
          <ul style={ul}>
            <li>Tu nombre y un medio para responderte.</li>
            <li>Un documento que acredite tu identidad (o la de tu representante y el documento que lo acredite).</li>
            <li>Qué derecho quieres ejercer y sobre qué datos.</li>
          </ul>
          <p style={{ ...p, margin: 0 }}>
            Te responderemos en un plazo máximo de 20 días hábiles y, si procede, haremos efectivo tu derecho dentro de los 15 días
            hábiles siguientes. Si consideras que tu derecho no fue atendido, puedes acudir a la autoridad competente en materia
            de protección de datos personales.
          </p>
        </Seccion>

        <Seccion n={7} titulo="Cookies y tecnologías similares">
          <p style={{ ...p, margin: 0 }}>
            Nuestro sistema solo usa el almacenamiento del navegador necesario para mantener abierta la sesión del personal
            autorizado. No usamos cookies publicitarias ni de rastreo en esta página.
          </p>
        </Seccion>

        <Seccion n={8} titulo="Cambios a este aviso">
          <p style={{ ...p, margin: 0 }}>
            Cualquier cambio a este aviso se publicará en esta misma dirección, con su fecha de última actualización.
          </p>
        </Seccion>

        <div style={{ textAlign: 'center', fontSize: 12, color: GRIS_CLARO, padding: '4px 0' }}>
          {RESPONSABLE.razonSocial} · Última actualización: {ULTIMA_ACTUALIZACION}
        </div>
      </main>
    </div>
  );
}
